'use strict';

var FlightDOWChartFilterFactory = function FlightDOWChartFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['FlightDateRangeFilterFactory', 'FlightLegFilterFactory', 'FlightCabinFilterFactory', 'FlightSeasonFilterFactory', 'FlightLevelFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function FlightDOWChartFilter() {
    DemandFilter.call(this, ['cabin', 'cabin-da', 'cabin-post-departure'], 'thematic-flight-chart-dow');
    this.registerFilters(injectedFilters);
  }
  FlightDOWChartFilter.prototype = Object.create(DemandFilter.prototype);
  FlightDOWChartFilter.prototype.canFilter = function (sourceType, targetType) {
    return this.sourceType.indexOf(sourceType) !== -1 && this.targetType === targetType;
  };
  return FlightDOWChartFilter;
};
FlightDOWChartFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = FlightDOWChartFilterFactory;